module.exports = __webpack_public_path__ + "img/he.033c38c0.svg";